import { render, staticRenderFns } from "./IframeGroupEditor.vue?vue&type=template&id=c378960e&"
import script from "./IframeGroupEditor.vue?vue&type=script&lang=js&"
export * from "./IframeGroupEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports